function trackComparisonEvent(eventName, eventData) {
    dataLayer.push({
      "event":eventName,
      "eventModel":eventData
    });
  }

document.addEventListener("DOMContentLoaded", function () {
  console.log("Event Listeners Active");

  // Overwrite Shopify.analytics.publish to intercept events
  if (Shopify.analytics && Shopify.analytics.publish) {
    const originalPublish = Shopify.analytics.publish;

    Shopify.analytics.publish = function (eventName, eventData) {
      console.log("Shopify Analytics Event Published:", eventName, eventData);

      // Handle comparison_product_viewed
      if (eventName === "comparison_product_viewed") {
        console.log("Product Viewed:", eventData.product.handle);

        // Send to Google Analytics
        trackComparisonEvent("comparison_product_viewed", {
          event_category: "Comparison Tool",
          event_label: eventData.product.handle,
        });
      }

      // Handle dynamic_comparison_modal_opened (if dispatched through Shopify.analytics.publish)
      if (eventName === "dynamic_comparison_modal_opened") {
        console.log("Modal Opened, Products:", eventData.products);

        // Send each product to Google Analytics
        eventData.products.forEach((product) => {
          trackComparisonEvent("dynamic_comparison_modal_opened", {
            event_category: "Comparison Tool",
            event_label: product.handle,
          });
        });
      }

      // Call the original publish method to preserve existing functionality
      return originalPublish.apply(this, arguments);
    };
  } else {
    console.warn("Shopify.analytics.publish is not available.");
  }

  // Listen for when a product is viewed in the comparison tool
  document.addEventListener("comparison_product_viewed", (event) => {
    console.log("Product Viewed (Custom Event):", event.detail.product.handle);

    // Send to Google Analytics
    trackComparisonEvent("comparison_product_viewed", {
      event_category: "Comparison Tool",
      event_label: event.detail.product.handle,
    });
  });

  // Listen for when the comparison modal opens
  document.addEventListener("dynamic_comparison_modal_opened", (event) => {
    console.log("Modal Opened (Custom Event), Products:", event.detail.products);

    // Send to Google Analytics
    event.detail.products.forEach((product) => {
      trackComparisonEvent("dynamic_comparison_modal_opened", {
        event_category: "Comparison Tool",
        event_label: product.handle,
      });
    });
  });

  // Listen for when a product is added to the comparison
  document.addEventListener("sc:dynamic-compare:add", (event) => {
    console.log("Product Added:", event.detail.productHandle);

    // Send to Google Analytics
    trackComparisonEvent("dynamic_comparison_product_added", {
      event_category: "Comparison Tool",
      event_label: event.detail.productHandle,
    });
  });

  // Listen for when a product is removed from the comparison
  document.addEventListener("sc:dynamic-compare:remove", (event) => {
    console.log("Product Removed:", event.detail.productHandle);

    // Send to Google Analytics
    trackComparisonEvent("dynamic_comparison_product_removed", {
      event_category: "Comparison Tool",
      event_label: event.detail.productHandle,
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Find the custom element containing the button
  const compareButtonWrapper = document.querySelector("sc-compare-dialog-open-button");

  if (compareButtonWrapper) {
    // Access the shadow root of the custom element
    const shadowRoot = compareButtonWrapper.shadowRoot;

    // Find the button inside the shadow root
    const compareButton = shadowRoot.querySelector("button");

    if (compareButton) {
      // Add event listener to the button
      compareButton.addEventListener("click", function () {
        // Dynamically get product name from meta tag
        const productName = document.querySelector('meta[property="og:title"]')?.content || "Unknown Product";

        console.log("Compare Goggles button clicked for product:", productName);

        // Send the event to Google Analytics
        trackComparisonEvent("compare_goggles_click", {
          event_category: "Button Click",
          event_label: productName, // Use the product name as the event label
          page_location: window.location.href, // Optional: Send the URL of the page
        });
      });
    } else {
      console.warn("Button inside shadow root not found.");
    }
  } else {
    console.warn("sc-compare-dialog-open-button element not found.");
  }
});
